import React from 'react';
export function Footer() {
  return <footer className="bg-navy pt-20 pb-10 border-t border-white/10" data-id="element-50">
      <div className="max-w-7xl mx-auto px-6" data-id="element-51">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-52">
          <div className="md:col-span-5" data-id="element-53">
            <div className="flex items-center gap-2 mb-6" data-id="element-54">
              <img src="https://cdn.magicpatterns.com/uploads/1PpJJn6acek23xVhxTKqe6/FullLogo_Transparent_(2).png" alt="TALVORI Talent" className="h-12 w-auto object-contain" data-id="element-55" />
              <span className="font-display font-bold text-2xl tracking-tight text-white" data-id="element-56">
                TALVORI
              </span>
            </div>
            <p className="text-slate-300 text-lg mb-8 max-w-md" data-id="element-57">
              Your strategic talent partner connecting global companies with
              exceptional professionals across Latin America.
            </p>
            <p className="text-slate-400 text-sm" data-id="element-58">
              Serving clients across the United States, Canada, and Europe.
            </p>
          </div>

          <div className="md:col-span-3" data-id="element-59">
            <h4 className="text-white font-bold mb-6" data-id="element-60">Navigation</h4>
            <ul className="space-y-4" data-id="element-61">
              {['Services', 'About', 'Roles', 'Pricing', 'Testimonials', 'FAQ'].map(item => <li key={item} data-id="element-62">
                  <a href={`#${item.toLowerCase()}`} className="text-slate-300 hover:text-white transition-colors" data-id="element-63">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          <div className="md:col-span-4" data-id="element-64">
            <h4 className="text-white font-bold mb-6" data-id="element-65">Contact</h4>
            <div className="space-y-6" data-id="element-66">
              <a href="mailto:partners@talvoritalents.org" className="block text-slate-300 hover:text-white transition-colors" data-id="element-67">
                partners@talvoritalents.org
              </a>
              <a href="https://calendly.com/partners-talvoritalents/30min?month=2026-06" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 text-sm font-semibold text-navy bg-white rounded-full hover:bg-slate-100 transition-colors" data-id="element-68">
                Book a Free Consultation
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between text-sm text-slate-400" data-id="element-69">
          <p data-id="element-70">© {new Date().getFullYear()} TALVORI. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0" data-id="element-71">
            <a href="#" className="hover:text-white transition-colors" data-id="element-72">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-73">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}